var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8839 10.544C11.372 10.0559 11.372 9.26443 10.8839 8.77627L2.92893 0.821321C2.44078 0.333166 1.64932 0.333166 1.16117 0.821321C0.67301 1.30948 0.67301 2.10093 1.16117 2.58909L8.23223 9.66016L1.16117 16.7312C0.67301 17.2194 0.67301 18.0108 1.16117 18.499C1.64932 18.9871 2.44078 18.9871 2.92893 18.499L10.8839 10.544ZM8 10.9102H10V8.41016H8V10.9102Z",
    fill: "#40D9B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronForward);
export default __webpack_public_path__ + "static/media/chevron-forward.8073f941126cf8d019d435506070589d.svg";
export { ForwardRef as ReactComponent };